import {observer} from "mobx-react";
import {CustomerWidget} from "./CustomerWidget";
import {VehicleDocumentsWidget} from "./VehicleDocumentsWidget";

interface PageTopperCustomerVehicleProps {
    vin: string | undefined
    customerId: string | undefined
}

const PageTopperCustomerVehicleWidget = observer(function PageTopperCustomerVehicle({
    vin,
    customerId
                                                          }: PageTopperCustomerVehicleProps) {
    return <>
        <div className={"columns"}>
            <div className={"column is-half"} style={{display: 'flex', flex: '1'}}>
                <CustomerWidget customerId={customerId} />
            </div>
            <div className={"column is-half"} style={{display: 'flex', flex: '1'}}>
                <VehicleDocumentsWidget customerId={customerId} vin={vin} />
            </div>
        </div>
    </>
})
export {
    PageTopperCustomerVehicleWidget
}
